import {
  type WorkoutFormat,
  type WorkoutItemGroupType,
} from "api-client/legacy-trpc";
import { createContext, useContext } from "react";

export interface WorkoutItemGroupContextValue {
  wrapperRef: HTMLDivElement;
  format: WorkoutFormat | null;
  groupType: WorkoutItemGroupType | null;
}

export const workoutItemGroupContext =
  createContext<WorkoutItemGroupContextValue>(null!);

export function useWorkoutItemGroupContext() {
  return useContext(workoutItemGroupContext);
}

export function useParentSectionFormat(): WorkoutFormat | null {
  const context = useContext(workoutItemGroupContext);
  return context?.format ?? null;
}

export function useParentSectionGroupType(): WorkoutItemGroupType | null {
  const context = useContext(workoutItemGroupContext);
  return context?.groupType ?? null;
}
